import React from 'react'
import Grid from '@material-ui/core/Grid'
import DatePicker from 'antd/es/date-picker'
import Button from '@material-ui/core/Button'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import excelIcon from '../../assets/img/ExcelIcon.svg'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import ClearIcon from '@material-ui/icons/Clear'
import { FormControl, Input, InputLabel } from '@material-ui/core'
import { useEffect, useState } from 'react'
import SearchIcon from '@material-ui/icons/Search'

const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    height: '32px',
    width: '32px',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'white',
    color: '#7A9BC2',
    border: '1px solid #7A9BC2',
    marginBottom: "3px"
}

const searchButton = {
    border: '1px solid #7A9BC2',
    background: 'white',
    color: '#7A9BC2',
    borderRadius: '0px',
    width: '70px',
    height: '31px',
    fontSize: '14px',
    textTransform: "initial"
}

const searchInput = {
    border: '1px solid #7A9BC2',
    background: 'white',
    borderRadius: '3px',
    width: '135px',
    height: '32px',
    fontSize: '14px',
    textTransform: "initial"
}

const buttons = 
{
    marginBottom : "3px"
}

const TableFilterComponent = ({ filterText, onFilter, onSearch,  onClear, onStartDateChange, onEndDateChange, onClickSearch, onExport, styles,}) => {
    const { t } = useTranslation();

    return (
        <>
            <Grid container spacing={1}>
                <Grid container item xs={12}>
                    <Grid container item xs={6}>
                        <Grid item xs={4}>
                            <DatePicker style={{ width: '190px' }} onChange={onStartDateChange} placeholder={t('common.from')} />
                        </Grid>
                        <Grid item xs={4}>
                            <DatePicker style={{ width: '190px' }} onChange={onEndDateChange} placeholder={t('common.toDate')} />
                        </Grid>
                        <Grid item xs={4}>
                            <Tooltip title={t('common.search')}>
                                <Button type="button" variant="contained" onClick={onClickSearch} style={searchButton}>{t('common.search')}</Button>
                            </Tooltip>
                        </Grid>
                    </Grid>
                    <Grid item xs={6} className={styles}>
                        <Grid>
                        <TextField id="search" placeholder={t('common.search')} aria-label="Search Input" value={filterText}
                                onChange={onFilter}  style={searchInput}/>
                        <Tooltip title='Buscar'>
                            <IconButton type="button" variant="contained" color="primary" onClick={onSearch} style={ClearButton} height="100">
                                <SearchIcon />
                            </IconButton>
                        </Tooltip>
                            <Tooltip title={t('common.clear')}>
                                <IconButton type="button" variant="contained" onClick={onClear} color="primary" style={ClearButton}>
                                    <ClearIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={t('common.downloadFile')}>
                                <IconButton type="button" variant="outlined" onClick={e => onExport(e.target.value)} style={ClearButton}>
                                    <img src={excelIcon} alt="excel-icon" width="22" height="22" />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default TableFilterComponent
